// Типы для системы кланов
export interface Clan {
  id: string;
  name: string;
  tag: string;
  description: string;
  clanType: ClanType;
  logoUrl?: string;
  leaderId: string;
  leaderName: string;
  seniorOfficerId?: string;
  seniorOfficerName?: string;
  memberIds: string[];
  memberNames: string[];
  points: number;
  rank: number;
  rankName: string;
  achievements: ClanAchievement[];
  achievementsIds: string[];
  state: string; // Обязательное поле - штат клана
  primaryBase: string; // Основная база клана
  secondaryBases: string[]; // Второстепенные базы (максимум 10)
  totalMissions: number;
  totalWins: number;
  winRate: number;
  clanGameStatistics?: {
    totalMissions: number;
    totalGames: number;
    totalAirsoftGames: number;
    totalPaintballGames: number;
    totalSpeedballGames: number;
    totalWins: number;
    winRate: number;
  };
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}


export interface ClanAchievement {
  id: string;
  name: string;
  description: string;
  iconUrl: string;
  earnedAt: string;
  rarity: 'Common' | 'Rare' | 'Epic' | 'Legendary';
}

export interface ClanRank {
  id: string;
  level: number;
  name: string;
  pointsRequired: number;
  description: string;
  iconUrl: string;
  color: string;
  isActive: boolean;
  createdAt: string;
}

export interface PlayerAchievement {
  id: string;
  name: string;
  description: string;
  iconUrl: string;
  earnedAt: string;
  rarity: 'Common' | 'Rare' | 'Epic' | 'Legendary';
  category: string;
}

export interface ClanMember {
  id: string;
  name: string;
  email: string;
  clanRole: 'Leader' | 'Officer' | 'Member';
  humanFactionRank: number;
  humanFactionRankName: string;
  humanFactionPoints: number;
  alienFactionRank: number;
  alienFactionRankName: string;
  alienFactionPoints: number;
  totalMissions: number;
  totalWins: number;
  winRate: number;
  gameStatistics?: {
    totalGames: number;
    winRate: number;
    totalWins: number;
    totalLoses: number;
    totalAirsoftGames: number;
    totalPaintballGames: number;
    totalSpeedballGames: number;
    airsoftStatistics?: {
      winRate: number;
      totalWins: number;
      totalLoses: number;
    };
    paintballStatistics?: {
      winRate: number;
      totalWins: number;
      totalLoses: number;
    };
    speedballStatistics?: {
      winRate: number;
      totalWins: number;
      totalLoses: number;
    };
  };
  achievements: PlayerAchievement[];
  createdAt: string;
}

export interface CreateClanRequest {
  name: string;
  description: string;
  tag: string;
  clanType: string;
  state: string; // Обязательное поле - штат клана
  primaryBase: string; // Основная база клана
  secondaryBases: string[]; // Второстепенные базы (максимум 10)
  logoFile?: File;
}

export interface ClanSearchResult {
  clans: Clan[];
  total: number;
}

// Интерфейс для ответа с пагинацией
export interface ClanListResponse {
  clans: Clan[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasMore: boolean;
}


export const ACHIEVEMENT_RARITIES = {
  Common: { color: '#9E9E9E', label: 'Common' },
  Rare: { color: '#2196F3', label: 'Rare' },
  Epic: { color: '#9C27B0', label: 'Epic' },
  Legendary: { color: '#FF9800', label: 'Legendary' }
};

export const CLAN_ROLES = {
  Leader: { label: 'Clan Leader', color: '#FF5722' },
  Officer: { label: 'Officer', color: '#FF9800' },
  Member: { label: 'Member', color: '#4CAF50' }
};

// Константы типов кланов
export const CLAN_TYPES = {
  AIRSOFT: 'airsoft',
  PAINTBALL: 'paintball'
} as const;

export const CLAN_TYPE_LABELS = {
  [CLAN_TYPES.AIRSOFT]: 'Airsoft',
  [CLAN_TYPES.PAINTBALL]: 'Paintball'
} as const;

export type ClanType = typeof CLAN_TYPES[keyof typeof CLAN_TYPES];

// Типы для системы заявок/приглашений
export interface ClanRequest {
  id: string;
  clanId: string;
  clanName: string;
  userId: string;
  userName: string;
  type: 'application' | 'invitation';
  status: 'pending' | 'accepted' | 'declined' | 'expired' | 'withdrawn';
  createdBy?: string;
  createdByName?: string;
  clanType: string;
  createdAt: string;
  updatedAt: string;
}

export interface ClanRequestStats {
  pendingInvitations: number;
  pendingApplications: number;
  totalPending: number;
}

export interface ApplyToClanRequest {
  clanId: string;
}

export interface ClanInvitationRequest {
  userId: string;
} 